import React, { Component } from 'react'
import { Link } from 'gatsby'
import * as styles from './header.module.css'

export default class Header extends Component {

  render() {
    const title = this.props.title
    let sitename = (this.props.h1) ? <h1>{title}</h1> : <div className={styles.site_name}>{title}</div>
    return (
      <div className={styles.headarea}>
        <header>
          <Link to={`/`}>{sitename}</Link>
          <p>爆乳の谷間でしっかり挟射させる動画を紹介するエログ</p>
          <p>本サイトはプロモーションを含んでおります。</p>
        </header>
      </div>
    )
  }
}